import { useState } from "react";
import { BrowserView, isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";

export default function OurBusinessArea(props){

    const links = ["Residential","Commercial","Yatching","Cource"];
    const { t } = useTranslation();
    const [selectedTabIndex,setSelectedTabIndex] = useState(0);

    return(
        <>
            <div className="content-and-image">
                    <div id="content">
                        {!isMobile ?
                        <div id="image">
                            <img src="5379637510122105173.jpg"/>
                        </div>  
                        :""}
                        <div id="text-right">
                            <div>
                                <div id='title'>{t('A propos de nos activités')}</div>
                                <br/>
                                <br/>
                                <div id = 'text'>
                                Avez-vous une expérience de longue date dans le secteur immobilier et cherchez-vous 
                                    Pour de nouveaux défis et une perspective de carrière prometteuse ? En tant qu’agent immobilier chez 
                                    LM Platinium, vous pouvez utiliser vos compétences pour construire une carrière réussie.
                                    <br/>
                                    <br/>
                                    En tant qu’agent immobilier indépendant et mobile, vous bénéficiez de notre expansion mondiale 
                                    Réseau de clients exclusifs et des propriétés correspondantes.

                                    <br/>
                                    <br/>
                                    <br/>
                                </div>
                                <div className="blue-button" style={{width:"230px"}} onClick={props.showContactsClick}>{t('Postulez maintenant')}</div>
                            </div>
                        </div>
                        {isMobile ?
                        <div id="image">
                            <img src="5379637510122105173.jpg"/>
                        </div>  
                        :""}
                    </div>
            </div>
        </>
    )
}
